export default __webpack_public_path__ + "KaTeX_Size2-Regular.f516b73c4a7ccca3d1a761dee3133a87.woff2";